import { render, staticRenderFns } from "./batchlist.vue?vue&type=template&id=fec3bf6a&scoped=true&"
import script from "./batchlist.vue?vue&type=script&lang=js&"
export * from "./batchlist.vue?vue&type=script&lang=js&"
import style0 from "./batchlist.vue?vue&type=style&index=0&id=fec3bf6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec3bf6a",
  null
  
)

export default component.exports